import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Layout from "../components/Layout/Layout";
import BannerHeroSection from "../components/HeroSection/BannerHeroSection";
import TrainingHero from "../assets/TrainingHero.png";
import axios from "axios";
import verticalDots from "../assets/verticalDots.svg";
import trainingCarousalImage from "../assets/trainingCarousalImage.png";
import Event from "../components/Event";
import { useStrapperContext } from "../components/Strapper/StrapperContext";
import SearchableSelect from "../components/Event/SearchableSelect";
import Frequently from "../components/Homepage/FrequentlyAskQuestion";
import { useParams } from "react-router-dom";
const moment = require("moment");

const CourseAbout = () => {
  const location = useLocation();
  const { straper, setStraper } = useStrapperContext();
  const id = location.state?.courseId;
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeSection, setActiveSection] = useState("overview");
  const [isRegister, setRegister] = useState(false);
  const handleClosRegistereModal = () => setRegister(false);
  const [language, setLanguage] = useState("English");
  const [selectedVenue, setSelectedVenue] = useState("All locations");
  const [venueOptions, setVenueOptions] = useState([]);
  const [registerEvent, setRegisterEvent] = useState({});
  const [eventCourse, setEventCourse] = useState({});
  const [campuses, setCampuses] = useState([]);
  const [uniqueLanguages, setUniqueLanguages] = useState([]);
  const { name } = useParams();

  const bubbleSVG1 = (
    <svg
      width="120"
      height="120"
      viewBox="0 0 165 165"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="165"
        y="165"
        width="165"
        height="165"
        rx="82.5"
        transform="rotate(180 165 165)"
        fill="#E9EFFF"
      />
    </svg>
  );

  const bubbleSVG2 = (
    <svg
      width="300"
      height="300"
      viewBox="0 0 464 464"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="464" height="464" rx="232" fill="#E9EFFF" />
    </svg>
  );

  const bulletPointSVG = (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.61932 9.85227L0.676136 6.90909L3.61932 4.00568L6.5625 6.90909L3.61932 9.85227ZM3.61932 8.65909L5.36932 6.90909L3.61932 5.15909L1.86932 6.90909L3.61932 8.65909ZM7.39773 13.5909L4.45455 10.6875L7.39773 7.74432L10.3011 10.6875L7.39773 13.5909ZM7.39773 12.3977L9.10795 10.6875L7.39773 8.9375L5.64773 10.6875L7.39773 12.3977ZM11.1364 9.85227L8.23295 6.90909L11.1364 4.00568L14.0398 6.90909L11.1364 9.85227ZM11.1364 8.65909L12.8864 6.90909L11.1364 5.15909L9.38636 6.90909L11.1364 8.65909ZM7.39773 6.07386L4.45455 3.17045L7.39773 0.227272L10.3011 3.17045L7.39773 6.07386ZM7.39773 4.88068L9.10795 3.17045L7.39773 1.42045L5.64773 3.17045L7.39773 4.88068Z"
        fill="#073967"
      />
    </svg>
  );

  const handleOpenRegistereModal = (event, course) => {
    setStraper(1);
    setRegisterEvent(event);
    setEventCourse(course);
    setRegister(true);
  };

  useEffect(() => {
    const getCategory = () => {
      if (id) {
        axios
          .get(`${process.env.REACT_APP_BASE_URL}/course/${id}`)
          .then((response) => {
            setCourse(response?.data?.data?.category);
            setCampuses(response?.data?.data?.campuses);
            setLoading(false);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
            setLoading(false);
          });
      } else {
        axios
          .get(`${process.env.REACT_APP_BASE_URL}/course/name/${name}`)
          .then((response) => {
            setCourse(response?.data?.data?.category);
            setCampuses(response?.data?.data?.campuses);
            setLoading(false);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
            setLoading(false);
          });
      }
    };
    getCategory();
  }, [id, name]);

  useEffect(() => {
    if (course && course.campuses) {
      const optionsArray = course?.campuses;
      setVenueOptions(optionsArray);
    }
  }, [course]);

  useEffect(() => {
    if (course?.events) {
      const languages = [
        ...new Set(course.events.map((event) => event?.language)),
      ];
      const filteredLanguages = languages?.filter((value) => {
        return value && value.trim() !== "";
      });
      setUniqueLanguages(filteredLanguages);
      setLanguage("All languages");
    }
  }, [course]);

  const handleVenueChange = (event) => {
    setSelectedVenue(event);
  };

  const spiltCourseName = (name) => {
    const res = name.split("—");
    return res[0];
  };

  const checkCampusFromSelectedVenue = (venue, campus) => {
    return venue.includes(campus);
  };

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-screen">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#B02526]"></div>
        </div>
      </Layout>
    );
  }

  if (!course) {
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-[#183864] mb-4">
              Course Not Found
            </h2>
            <p className="text-[#777777]">
              The course you're looking for doesn't exist.
            </p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <>
      {isRegister && (
        <Event
          event={registerEvent}
          course={eventCourse}
          spiltCourseName={spiltCourseName}
          isRegister={isRegister}
          handleClosRegistereModal={handleClosRegistereModal}
          straper={straper}
          setStraper={setStraper}
        />
      )}
      <Layout>
        {/* Main Content */}
        <div className="relative overflow-hidden bg-gradient-to-b from-white to-gray-50">
          {/* Background Decorations - Desktop only */}
          <div className="hidden md:block absolute left-2 top-20 -z-10 opacity-50">
            <img className="w-12 md:w-16 lg:w-20" src={verticalDots} alt="" />
          </div>

          <div className="hidden lg:block absolute right-4 top-1/4 -z-10 opacity-30">
            {bubbleSVG1}
          </div>

          <div className="hidden lg:block absolute left-1/2 top-2/3 -z-10 opacity-20">
            {bubbleSVG2}
          </div>

          <div className="hidden lg:block absolute right-2 bottom-20 -z-10 opacity-50">
            <img className="w-16 lg:w-20" src={verticalDots} alt="" />
          </div>

          {/* Course Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="container mx-auto px-4 md:px-12 lg:px-16 py-4 md:py-12 lg:py-16"
          >
            <div className="">
              {/* Banner Hero Section */}
              <BannerHeroSection
                title={course?.title || course?.name || "Course Details"}
                // subtitle={`Professional training program designed to enhance your skills and advance your career`}
                bannerImage={
                  course?.image
                    ? `${process.env.REACT_APP_BASE_URL}/${course.image}`
                    : TrainingHero
                }
                height="h-64 md:h-80 lg:h-96 xl:h-[500px]"
                className="-mx-4 md:-mx-12 lg:-mx-16 mb-6 md:mb-8 lg:mb-10"
                showOverlay={true}
              ></BannerHeroSection>

              {/* Mobile: Tab Navigation */}
              <div className="md:hidden mb-4">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                  className="flex bg-gray-100 rounded-xl p-1 mb-4"
                >
                  {[
                    { id: "overview", label: "Overview", icon: "📋" },
                    { id: "curriculum", label: "Topics", icon: "📚" },
                    { id: "events", label: "Events", icon: "📅" },
                  ].map((tab) => (
                    <button
                      key={tab.id}
                      onClick={() => setActiveSection(tab.id)}
                      className={`flex-1 flex items-center justify-center gap-1 py-2 px-3 rounded-lg text-xs font-medium transition-all duration-200 ${
                        activeSection === tab.id
                          ? "bg-[#183864] text-white shadow-sm"
                          : "text-gray-600 hover:text-[#183864]"
                      }`}
                    >
                      <span>{tab.icon}</span>
                      <span>{tab.label}</span>
                    </button>
                  ))}
                </motion.div>
              </div>

              {/* Mobile: Dynamic Content Based on Active Tab */}
              <div className="md:hidden">
                {/* Overview Tab */}
                {activeSection === "overview" && (
                  <motion.div
                    key="overview"
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    className="space-y-4"
                  >
                    {/* Course Highlights */}
                    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-4 border border-blue-100">
                      <h3 className="text-lg font-bold text-[#183864] mb-3 flex items-center gap-2">
                        <span>✨</span> Course Highlights
                      </h3>
                      <div className="grid grid-cols-2 gap-3">
                        <div className="text-center">
                          <div className="text-2xl mb-1">🎓</div>
                          <div className="text-xs text-gray-600 font-medium">
                            Professional
                          </div>
                          <div className="text-xs text-gray-600">
                            Certification
                          </div>
                        </div>
                        <div className="text-center">
                          <div className="text-2xl mb-1">👥</div>
                          <div className="text-xs text-gray-600 font-medium">
                            Expert
                          </div>
                          <div className="text-xs text-gray-600">
                            Instructors
                          </div>
                        </div>
                        <div className="text-center">
                          <div className="text-2xl mb-1">📚</div>
                          <div className="text-xs text-gray-600 font-medium">
                            Comprehensive
                          </div>
                          <div className="text-xs text-gray-600">Materials</div>
                        </div>
                        <div className="text-center">
                          <div className="text-2xl mb-1">🏆</div>
                          <div className="text-xs text-gray-600 font-medium">
                            Industry
                          </div>
                          <div className="text-xs text-gray-600">
                            Recognized
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Description Card */}
                    {course.description && (
                      <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
                        <h3 className="text-lg font-bold text-[#183864] mb-3 flex items-center gap-2">
                          <span>📖</span> About This Course
                        </h3>
                        <div
                          className="text-sm text-[#777777] leading-relaxed"
                          dangerouslySetInnerHTML={{
                            __html: course.description,
                          }}
                        />
                      </div>
                    )}

                    {/* Course Details */}
                    <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
                      <h3 className="text-lg font-bold text-[#183864] mb-4 flex items-center gap-2">
                        <span>📊</span> Course Details
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        {course.duration && (
                          <div className="bg-gradient-to-br from-[#183864] to-[#2a4d7a] text-white rounded-xl p-4 text-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                            <div className="text-2xl font-bold mb-2">⏱️</div>
                            <div className="text-xs font-medium opacity-90 mb-1">
                              Duration
                            </div>
                            <div
                              className="text-sm font-bold"
                              dangerouslySetInnerHTML={{
                                __html: course.duration,
                              }}
                            />
                          </div>
                        )}
                        {course.price && (
                          <div className="bg-gradient-to-br from-[#B02526] to-[#8B1E1F] text-white rounded-xl p-4 text-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                            <div className="text-2xl font-bold mb-2">💰</div>
                            <div className="text-xs font-medium opacity-90 mb-1">
                              Price
                            </div>
                            <div className="text-sm font-bold">
                              ${course.price}
                            </div>
                          </div>
                        )}
                        {course.certificateValidity && (
                          <div className="bg-gradient-to-br from-purple-500 to-pink-500 text-white rounded-xl p-4 text-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                            <div className="text-2xl font-bold mb-2">📋</div>
                            <div className="text-xs font-medium opacity-90 mb-1">
                              Certificate
                            </div>
                            <div className="text-sm font-bold">
                              {course.certificateValidity}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* What you will learn */}
                    {course.objectives && course.objectives.length > 0 && (
                      <div className="bg-gradient-to-r from-[#183864] to-[#2a4d7a] rounded-2xl p-4 text-white">
                        <h3 className="text-lg font-bold mb-3 flex items-center gap-2">
                          <span>🎯</span> What You Will Learn
                        </h3>
                        <ul className="space-y-1">
                          {course.objectives.map((objective, index) => (
                            <li
                              key={index}
                              className="flex items-start gap-2 text-sm"
                            >
                              <span className="text-[#B02526] text-base mt-0.5">
                                •
                              </span>
                              <span>{objective}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {/* Prerequisites */}
                    {course.prerequisites &&
                      course.prerequisites.length > 0 && (
                        <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
                          <h3 className="text-lg font-bold text-[#183864] mb-3 flex items-center gap-2">
                            <span>✅</span> Prerequisites
                          </h3>
                          <ul className="space-y-1">
                            {course.prerequisites.map((prerequisite, index) => (
                              <li
                                key={index}
                                className="flex items-start gap-2 text-sm text-[#777777]"
                              >
                                <span className="text-[#B02526] text-base mt-0.5">
                                  •
                                </span>
                                <span>{prerequisite}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}

                    {/* Campuses */}
                    <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
                      <h3 className="text-lg font-bold text-[#183864] mb-3 flex items-center gap-2">
                        <span>📍</span> Available Campuses
                      </h3>
                      {course?.manualCampus ? (
                        <ul className="space-y-2">
                          {course?.campuses?.map((campus, index) => (
                            <li key={index} className="text-sm text-[#777777]">
                              • {campus}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <ul className="space-y-2">
                          {campuses?.map((campus) => (
                            <li key={campus._id} className="text-sm">
                              <a
                                href={`/contact/${campus._id}`}
                                className="text-[#073967] hover:text-[#073967]/80 underline"
                              >
                                • {campus.name}
                              </a>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </motion.div>
                )}

                {/* Topics Tab */}
                {activeSection === "curriculum" && (
                  <motion.div
                    key="curriculum"
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    className="space-y-3"
                  >
                    {course.objectives && course.objectives.length > 0 ? (
                      <>
                        <h3 className="text-lg font-bold text-[#183864] mb-4 flex items-center gap-2">
                          <span>🎯</span> What You'll Learn
                        </h3>
                        {course.objectives.map((objective, index) => (
                          <div
                            key={index}
                            className="bg-white rounded-xl p-4 shadow-sm border border-gray-100"
                          >
                            <div className="flex items-start gap-3">
                              <span className="bg-[#B02526] text-white w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold mt-1">
                                {index + 1}
                              </span>
                              <p className="text-sm text-[#777777] leading-relaxed">
                                {objective}
                              </p>
                            </div>
                          </div>
                        ))}
                      </>
                    ) : (
                      <div className="text-center py-8">
                        <p className="text-gray-500">
                          No curriculum details available
                        </p>
                      </div>
                    )}
                  </motion.div>
                )}

                {/* Events Tab */}
                {activeSection === "events" && (
                  <motion.div
                    key="events"
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    className="space-y-4"
                  >
                    {/* Language Selection */}
                    <div className="bg-gradient-to-r from-[#183864] to-[#2a4d7a] rounded-2xl p-4 text-white">
                      <h3 className="text-lg font-bold flex items-center gap-2">
                        <span>📅</span> Available Classes
                      </h3>
                    </div>
                    {uniqueLanguages.length > 0 && (
                      <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
                        <h3 className="text-lg font-bold text-[#183864] mb-3 flex items-center gap-2">
                          <span>🌐</span> Course Languages
                        </h3>
                        <div className="relative z-10">
                          <SearchableSelect
                            options={uniqueLanguages}
                            selectedValue={language}
                            onChange={setLanguage}
                            placeholder="Select a language"
                            showAllOption={true}
                            allOptionText="All languages"
                          />
                        </div>
                      </div>
                    )}

                    {/* Location Filter */}
                    {venueOptions.length > 0 && (
                      <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
                        <h3 className="text-lg font-bold text-[#183864] mb-3 flex items-center gap-2">
                          <span>📍</span> Select Location
                        </h3>
                        <div className="relative z-10">
                          <SearchableSelect
                            options={venueOptions}
                            selectedValue={selectedVenue}
                            onChange={handleVenueChange}
                            placeholder="Select a location"
                            showAllOption={true}
                            allOptionText="All locations"
                          />
                        </div>
                      </div>
                    )}

                    {/* Events List */}
                    <div className="space-y-3">
                      {course?.events
                        ?.filter((item) => {
                          const currentDate = moment();
                          const onSaleDate = moment.utc(item.onSale);
                          const endDate = moment.utc(item.endDate);

                          return (
                            (language === "All languages" ||
                              item.language?.toLowerCase() ===
                                language?.toLowerCase()) &&
                            (selectedVenue === "All locations" ||
                              checkCampusFromSelectedVenue(
                                selectedVenue,
                                item?.campus,
                              )) &&
                            (item.eventType?.toLowerCase() === "public" ||
                              item.eventType?.toLowerCase() ===
                                "redirect-events") &&
                            item.eventStatus?.toLowerCase() === "active" &&
                            currentDate.isSameOrAfter(onSaleDate) &&
                            currentDate.isBefore(endDate)
                          );
                        })
                        ?.map((item, index) => (
                          <div
                            key={index}
                            className="bg-white rounded-xl p-4 shadow-md border border-gray-100 hover:shadow-lg transition-all duration-300"
                          >
                            <div className="flex items-center justify-between mb-3">
                              <div className="flex items-center gap-2">
                                {bulletPointSVG}
                                <h4 className="text-base font-bold text-[#183864]">
                                  {spiltCourseName(course?.name)}
                                </h4>
                              </div>
                            </div>

                            <div className="space-y-2 mb-4">
                              {/* Single line with date, location, and time */}
                              <div className="flex justify-between w-full">
                                <div className="flex flex-col gap-2 text-sm text-gray-600">
                                  <span className="inline-flex items-center gap-1">
                                    <span>📅</span>
                                    <span>
                                      {moment(item?.endDate, "YYYY-MM-DD").diff(
                                        moment(item?.startDate, "YYYY-MM-DD"),
                                        "days",
                                      ) >= 1
                                        ? `${moment(item?.startDate, "YYYY-MM-DD").format("MMM DD")} - ${moment(item?.endDate, "YYYY-MM-DD").format("MMM DD, YYYY")}`
                                        : moment(
                                            item?.startDate,
                                            "YYYY-MM-DD",
                                          ).format("MMM DD, YYYY")}
                                    </span>
                                  </span>

                                  <div>
                                    {item?.timing && (
                                      <>
                                        <span className="inline-flex items-center gap-1">
                                          <span>⏰</span>
                                          <span>{item.timing}</span>
                                        </span>
                                      </>
                                    )}
                                  </div>
                                  <span className="inline-flex items-center gap-1">
                                    <span>📍</span>
                                    <span>{item?.campus}</span>
                                  </span>
                                </div>
                                <button
                                  onClick={() =>
                                    handleOpenRegistereModal(item, course)
                                  }
                                  className="bg-[#B02526] text-white px-6 py-2 rounded-lg font-bold text-sm hover:bg-[#d63031] transition-colors duration-200 h-max mt-8"
                                >
                                  Register Now
                                </button>
                              </div>

                              {/* Available seats */}
                              <div className="flex items-center gap-2 text-sm text-orange-600">
                                <span>👥</span>
                                <span>
                                  {item.seatsTotal - item.seatsOccupied > 0
                                    ? `${item.seatsTotal - item.seatsOccupied} seats available`
                                    : "0 seats available"}
                                </span>
                              </div>
                            </div>
                          </div>
                        )) || (
                        <div className="text-center py-12 bg-white rounded-xl shadow-sm border border-gray-100">
                          <div className="text-4xl mb-4">😔</div>
                          <h3 className="text-lg font-semibold text-gray-700 mb-2">
                            No Classes Available
                          </h3>
                          <p className="text-gray-500 mb-4">
                            No classes match your selected criteria. Try
                            different filters or check back later.
                          </p>
                          <button
                            onClick={() => {
                              setLanguage("All languages");
                              setSelectedVenue("All locations");
                            }}
                            className="bg-[#B02526] text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#d63031] transition-colors duration-200"
                          >
                            Reset Filters
                          </button>
                        </div>
                      )}
                    </div>
                  </motion.div>
                )}

                {/* Mobile CTA */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.6 }}
                  className="mt-6 sticky bottom-4 z-10"
                >
                  <div className="bg-gradient-to-r from-[#B02526] to-[#d63031] rounded-2xl p-4 text-white shadow-lg">
                    <div className="text-center mb-3">
                      <h3 className="text-lg font-bold mb-1 flex items-center justify-center gap-2">
                        🎓 Ready to Start?
                      </h3>
                      <p className="text-sm opacity-90">
                        Join thousands of successful students
                      </p>
                      {course?.price && (
                        <p className="text-xs opacity-80 mt-1">
                          Starting at ${course.price} CAD + GST
                        </p>
                      )}
                    </div>
                    <div className="flex gap-3">
                      <button
                        onClick={() => setActiveSection("events")}
                        className="flex-1 bg-white text-[#B02526] py-3 rounded-xl font-bold text-sm hover:bg-gray-100 transition-colors duration-300 flex items-center justify-center gap-2"
                      >
                        📅 Enroll Now
                      </button>
                      <button
                        onClick={() => setActiveSection("overview")}
                        className="flex-1 border-2 border-white text-white py-3 rounded-xl font-bold text-sm hover:bg-white hover:text-[#B02526] transition-colors duration-300 flex items-center justify-center gap-2"
                      >
                        📖 Learn More
                      </button>
                    </div>
                  </div>
                </motion.div>
              </div>

              {/* Desktop: Traditional Layout */}
              <div className="hidden md:block">
                {/* Mobile: Tab Navigation */}
                <div className="md:hidden mb-4">
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.4 }}
                    className="flex bg-gray-100 rounded-xl p-1 mb-4"
                  >
                    {[
                      { id: "overview", label: "Overview", icon: "📋" },
                      { id: "curriculum", label: "Topics", icon: "📚" },
                      { id: "events", label: "Events", icon: "📅" },
                    ].map((tab) => (
                      <button
                        key={tab.id}
                        onClick={() => setActiveSection(tab.id)}
                        className={`flex-1 flex items-center justify-center gap-1 py-2 px-3 rounded-lg text-xs font-medium transition-all duration-200 ${
                          activeSection === tab.id
                            ? "bg-[#183864] text-white shadow-sm"
                            : "text-gray-600 hover:text-[#183864]"
                        }`}
                      >
                        <span>{tab.icon}</span>
                        <span>{tab.label}</span>
                      </button>
                    ))}
                  </motion.div>
                </div>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.6 }}
                  className="mb-8 md:mb-12"
                >
                  <div className="text-center">
                    <button
                      onClick={() =>
                        window.scrollTo({
                          top: document.getElementById("course-events")
                            .offsetTop,
                          behavior: "smooth",
                        })
                      }
                      className="bg-[#B02526] hover:bg-[#d63031] text-white px-6 py-3 rounded-lg font-bold text-sm md:text-base transition-colors duration-300"
                    >
                      View Course Schedule
                    </button>
                  </div>
                </motion.div>
                {/* Course Description */}
                {course.description && (
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.6 }}
                    className="mb-8 md:mb-12"
                  >
                    <div className="bg-white rounded-xl md:rounded-2xl p-6 !py-2 md:p-8 shadow-sm border border-gray-100">
                      {/* <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-[#183864] mb-4 md:mb-6">
                        Dive Deeper into This Course
                      </h2> */}
                      <div
                        className="text-sm md:text-base lg:text-lg text-[#777777] leading-relaxed mb-6"
                        dangerouslySetInnerHTML={{ __html: course.description }}
                      />
                    </div>
                  </motion.div>
                )}

                {/* Course Details */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.65 }}
                  className="mb-8 md:mb-12"
                >
                  <div className="bg-white rounded-xl md:rounded-2xl p-6 md:p-8 shadow-lg border border-gray-100">
                    <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-[#183864] mb-6 flex items-center gap-3">
                      <span>📊</span> Course Details
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      {course.duration && (
                        <div className="bg-gradient-to-br from-[#183864] to-[#2a4d7a] text-white rounded-xl p-6 text-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                          <div className="text-3xl font-bold mb-3">⏱️</div>
                          <div className="text-xl font-medium opacity-90 mb-2">
                            Duration
                          </div>
                          <div
                            className="text-base font-bold"
                            dangerouslySetInnerHTML={{
                              __html: course.duration,
                            }}
                          />
                        </div>
                      )}
                      {course.price && (
                        <div className="bg-gradient-to-br from-[#183864] to-[#2a4d7a] text-white rounded-xl p-6 text-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                          <div className="text-3xl font-bold mb-3">💰</div>
                          <div className="text-xl font-medium opacity-90 mb-2">
                            Price
                          </div>
                          <div className="text-base font-bold">
                            ${course.price} + GST
                          </div>
                        </div>
                      )}
                      {course.certificateValidity && (
                        <div className="bg-gradient-to-br from-[#183864] to-[#2a4d7a] text-white rounded-xl p-6 text-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                          <div className="text-3xl font-bold mb-3">📋</div>
                          <div className="text-xl font-medium opacity-90 mb-2">
                            Certificate Validity
                          </div>
                          <div className="text-base font-bold">
                            {course.certificateValidity}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </motion.div>

                {/* What You Will Learn and Campuses - Side by Side on Desktop */}
                <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-8 md:mb-12">
                  {/* What You Will Learn */}
                  {course.objectives && course.objectives.length > 0 && (
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5, delay: 0.7 }}
                    >
                      <div className="bg-white rounded-xl md:rounded-2xl p-6 md:p-8 shadow-sm border border-gray-100 h-full min-h-[300px] flex flex-col">
                        <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-[#183864] mb-4 md:mb-6">
                          What You Will Learn
                        </h2>
                        <ul className="space-y-2 md:space-y-3 flex-grow">
                          {course.objectives.map((objective, index) => (
                            <li
                              key={index}
                              className="flex items-start space-x-3"
                            >
                              <span className="text-[#B02526] text-lg mt-1">
                                •
                              </span>
                              <span className="text-sm md:text-base lg:text-lg text-[#777777]">
                                {objective}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </motion.div>
                  )}

                  {/* Campuses */}
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.8 }}
                  >
                    <div className="bg-white rounded-xl md:rounded-2xl p-6 md:p-8 shadow-sm border border-gray-100 h-full min-h-[300px] flex flex-col">
                      <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-[#183864] mb-4 md:mb-6 flex items-center gap-3">
                        <svg
                          fill="#183864"
                          version="1.1"
                          id="Capa_1"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24px"
                          height="24px"
                          viewBox="0 0 395.71 395.71"
                        >
                          <g>
                            <path
                              d="M197.849,0C122.131,0,60.531,61.609,60.531,137.329c0,72.887,124.591,243.177,129.896,250.388l4.951,6.738
                                    c0.579,0.792,1.501,1.255,2.471,1.255c0.985,0,1.901-0.463,2.486-1.255l4.948-6.738c5.308-7.211,129.896-177.501,129.896-250.388
                                    C335.179,61.609,273.569,0,197.849,0z M197.849,88.138c27.13,0,49.191,22.062,49.191,49.191c0,27.115-22.062,49.191-49.191,49.191
                                    c-27.114,0-49.191-22.076-49.191-49.191C148.658,110.2,170.734,88.138,197.849,88.138z"
                            />
                          </g>
                        </svg>
                        Available Campuses
                      </h2>

                      {course?.manualCampus ? (
                        <ul className="space-y-1 md:space-y-2 flex-grow">
                          {course?.campuses?.map((campus, index) => (
                            <li
                              key={index}
                              className="flex items-start space-x-3"
                            >
                              <span className="text-[#B02526] text-lg mt-1">
                                •
                              </span>
                              <span className="text-sm md:text-base lg:text-lg text-[#777777]">
                                {campus}
                              </span>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <ul className="space-y-1 md:space-y-2 flex-grow">
                          {campuses?.map((campus) => (
                            <li
                              key={campus._id}
                              className="flex items-start space-x-3"
                            >
                              <span className="text-[#B02526] text-lg mt-1">
                                •
                              </span>
                              <a
                                href={`/contact/${campus._id}`}
                                className="text-sm md:text-base lg:text-lg text-[#073967] hover:text-[#073967]/80 underline transition duration-200"
                              >
                                {campus.name}
                              </a>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </motion.div>
                </div>

                {/* Languages (if more than 2) */}
                {course?.language && course.language.length > 2 && (
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.85 }}
                    className="mb-8 md:mb-12"
                  >
                    <div className="bg-white rounded-xl md:rounded-2xl p-6 md:p-8 shadow-sm border border-gray-100">
                      <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-[#183864] mb-4 md:mb-6">
                        Available Languages
                      </h2>
                      <ul className="space-y-2 md:space-y-3">
                        {course.language.map((lang, index) => (
                          <li
                            key={index}
                            className="flex items-start space-x-3"
                          >
                            <span className="text-[#B02526] text-lg mt-1">
                              •
                            </span>
                            <span className="text-sm md:text-base lg:text-lg text-[#777777]">
                              {lang}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </motion.div>
                )}

                {/* Prerequisites */}
                {course.prerequisites && course.prerequisites.length > 0 && (
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.9 }}
                    className="mb-8 md:mb-12"
                  >
                    <div className="bg-white rounded-xl md:rounded-2xl p-6 md:p-8 shadow-sm border border-gray-100">
                      <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-[#183864] mb-4 md:mb-6">
                        Prerequisites
                      </h2>
                      <ul className="space-y-2 md:space-y-3">
                        {course.prerequisites.map((prerequisite, index) => (
                          <li
                            key={index}
                            className="flex items-start space-x-3"
                          >
                            <span className="text-[#B02526] text-lg mt-1">
                              •
                            </span>
                            <span className="text-sm md:text-base lg:text-lg text-[#777777]">
                              {prerequisite}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </motion.div>
                )}

                {/* Classes Section - After Prerequisites */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 1.0 }}
                  className="mb-8 md:mb-12"
                  id="course-events"
                >
                  <div className="bg-white rounded-xl md:rounded-2xl p-6 md:p-8 shadow-lg border border-gray-100">
                    <div className="text-center mb-8">
                      <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-[#183864] mb-4">
                        🎓 Enroll in Upcoming Classes
                      </h2>
                      <p className="text-gray-600 text-lg max-w-3xl mx-auto">
                        Choose your preferred schedule and location to begin
                        your certification journey
                      </p>
                    </div>

                    {/* Language and Location Selection */}
                    <div className="flex flex-col md:flex-row justify-center items-center gap-4 mb-6">
                      {uniqueLanguages.length > 0 && (
                        <div className="w-full md:w-[30%]">
                          <label
                            htmlFor="language"
                            className="block text-lg font-bold text-[#183864] mb-2 text-center"
                          >
                            Language:
                          </label>
                          <div className="w-full">
                            <div className="relative z-10">
                              <SearchableSelect
                                options={uniqueLanguages}
                                selectedValue={language}
                                onChange={setLanguage}
                                placeholder="Select a language"
                                showAllOption={true}
                                allOptionText="All languages"
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {venueOptions.length > 0 && (
                        <div className="w-full md:w-[30%]">
                          <label
                            htmlFor="location"
                            className="block text-lg font-bold text-[#183864] mb-2 text-center"
                          >
                            Location:
                          </label>
                          <div className="w-full">
                            <div className="relative z-10">
                              <SearchableSelect
                                options={venueOptions}
                                selectedValue={selectedVenue}
                                onChange={handleVenueChange}
                                placeholder="Select a location"
                                showAllOption={true}
                                allOptionText="All locations"
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Events List */}
                    <div className="space-y-4">
                      <div className="bg-gradient-to-r from-[#183864] to-[#2a4d7a] rounded-lg p-6 text-white">
                        <h3 className="text-xl font-bold flex items-center gap-2">
                          📅 Available Classes
                        </h3>
                        <p className="text-sm opacity-90 mt-2">
                          Choose your preferred date and location to start your
                          certification journey
                        </p>
                      </div>

                      {course?.events
                        ?.filter((item) => {
                          const currentDate = moment();
                          const onSaleDate = moment.utc(item.onSale);
                          const endDate = moment.utc(item.endDate);

                          return (
                            (language === "All languages" ||
                              item.language?.toLowerCase() ===
                                language?.toLowerCase()) &&
                            (selectedVenue === "All locations" ||
                              checkCampusFromSelectedVenue(
                                selectedVenue,
                                item?.campus,
                              )) &&
                            (item.eventType?.toLowerCase() === "public" ||
                              item.eventType?.toLowerCase() ===
                                "redirect-events") &&
                            item.eventStatus?.toLowerCase() === "active" &&
                            currentDate.isSameOrAfter(onSaleDate) &&
                            currentDate.isBefore(endDate)
                          );
                        })
                        ?.map((item, index) => (
                          <div
                            key={index}
                            className="bg-white rounded-xl p-4 shadow-md border border-gray-100 hover:shadow-lg transition-all duration-300"
                          >
                            <div className="flex items-center justify-between mb-3">
                              <div className="flex items-center gap-2">
                                {bulletPointSVG}
                                <h4 className="text-base font-bold text-[#183864]">
                                  {spiltCourseName(course?.name)}
                                </h4>
                              </div>
                              <button
                                onClick={() =>
                                  handleOpenRegistereModal(item, course)
                                }
                                className="bg-[#B02526] text-white px-6 py-2 rounded-lg font-bold text-sm hover:bg-[#d63031] transition-colors duration-200"
                              >
                                Enroll Now
                              </button>
                            </div>

                            <div className="space-y-2 mb-4">
                              {/* Single line with date, location, and time */}
                              <div className="text-sm text-gray-600">
                                <span className="inline-flex items-center gap-1">
                                  <span>📅</span>
                                  <span>
                                    {moment(item?.endDate, "YYYY-MM-DD").diff(
                                      moment(item?.startDate, "YYYY-MM-DD"),
                                      "days",
                                    ) >= 1
                                      ? `${moment(item?.startDate, "YYYY-MM-DD").format("MMM DD")} - ${moment(item?.endDate, "YYYY-MM-DD").format("MMM DD, YYYY")}`
                                      : moment(
                                          item?.startDate,
                                          "YYYY-MM-DD",
                                        ).format("MMM DD, YYYY")}
                                  </span>
                                </span>
                                {item?.timing && (
                                  <>
                                    <span className="mx-1">•</span>
                                    <span className="inline-flex items-center gap-1">
                                      <span>⏰</span>
                                      <span>{item.timing}</span>
                                    </span>
                                  </>
                                )}
                                <span className="mx-1">•</span>
                                <span className="inline-flex items-center gap-1">
                                  <span>📍</span>
                                  <span>{item?.campus}</span>
                                </span>
                              </div>
                              {/* Course price */}
                              {/* Available seats */}
                              <div className="flex items-center gap-2 text-sm text-orange-600">
                                <span>👥</span>
                                <span>
                                  {item.seatsTotal - item.seatsOccupied > 0
                                    ? `${item.seatsTotal - item.seatsOccupied} seats available`
                                    : "0 seats available"}
                                </span>
                              </div>
                            </div>
                          </div>
                        )).length > 0 ? (
                        course?.events
                          ?.filter((item) => {
                            const currentDate = moment();
                            const onSaleDate = moment.utc(item.onSale);
                            const endDate = moment.utc(item.endDate);

                            return (
                              (language === "All languages" ||
                                item.language?.toLowerCase() ===
                                  language?.toLowerCase()) &&
                              (selectedVenue === "All locations" ||
                                checkCampusFromSelectedVenue(
                                  selectedVenue,
                                  item?.campus,
                                )) &&
                              (item.eventType?.toLowerCase() === "public" ||
                                item.eventType?.toLowerCase() ===
                                  "redirect-events") &&
                              item.eventStatus?.toLowerCase() === "active" &&
                              currentDate.isSameOrAfter(onSaleDate) &&
                              currentDate.isBefore(endDate)
                            );
                          })
                          ?.map((item, index) => (
                            <div
                              key={index}
                              className="bg-white rounded-xl p-4 shadow-md border border-gray-100 hover:shadow-lg transition-all duration-300"
                            >
                              <div className="flex items-center justify-between mb-3">
                                <div className="flex items-center gap-2">
                                  {bulletPointSVG}
                                  <h4 className="text-lg font-bold text-[#183864]">
                                    {spiltCourseName(course?.name)}
                                  </h4>
                                </div>
                                <button
                                  onClick={() =>
                                    handleOpenRegistereModal(item, course)
                                  }
                                  className="bg-[#B02526] text-white px-6 py-2 rounded-lg font-bold text-lg hover:bg-[#d63031] transition-colors duration-200 -mb-16"
                                >
                                  Register Now
                                </button>
                              </div>

                              <div className="space-y-2 mb-4">
                                {/* Single line with date, location, and time */}
                                <div className="text-lg text-gray-600">
                                  <span className="inline-flex items-center gap-1">
                                    <span>📅</span>
                                    <span>
                                      {moment(item?.endDate, "YYYY-MM-DD").diff(
                                        moment(item?.startDate, "YYYY-MM-DD"),
                                        "days",
                                      ) >= 1
                                        ? `${moment(item?.startDate, "YYYY-MM-DD").format("MMM DD")} - ${moment(item?.endDate, "YYYY-MM-DD").format("MMM DD, YYYY")}`
                                        : moment(
                                            item?.startDate,
                                            "YYYY-MM-DD",
                                          ).format("MMM DD, YYYY")}
                                    </span>
                                  </span>

                                  {item?.timing && (
                                    <>
                                      <span className="mx-1">•</span>
                                      <span className="inline-flex items-center gap-1">
                                        <span>⏰</span>
                                        <span>{item.timing}</span>
                                      </span>
                                    </>
                                  )}
                                  <span className="mx-1">•</span>
                                  <span className="inline-flex items-center gap-1">
                                    <span>📍</span>
                                    <span>{item?.campus}</span>
                                  </span>
                                </div>
                                {/* Available seats */}
                                <div className="flex items-center gap-2 text-lg text-orange-600">
                                  <span>👥</span>
                                  <span>
                                    {item.seatsTotal - item.seatsOccupied > 0
                                      ? `${item.seatsTotal - item.seatsOccupied} seats available`
                                      : "0 seats available"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))
                      ) : (
                        <div className="text-center py-8">
                          <h3 className="text-lg font-bold text-[#183864] mb-2">
                            No Classes Available
                          </h3>
                          <p className="text-gray-500 mb-6 max-w-md mx-auto">
                            No classes match your selected criteria. Try
                            adjusting your language or location preferences, or
                            check back later for new sessions.
                          </p>
                          <button
                            onClick={() => {
                              setLanguage("All languages");
                              setSelectedVenue("All locations");
                            }}
                            className="bg-[#B02526] text-white px-6 py-3 rounded-lg font-medium hover:bg-[#d63031] transition-colors duration-200"
                          >
                            Reset All Filters
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </motion.div>

                {/* Why Choose This Course */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 1.0 }}
                  className="mb-8 md:mb-12"
                >
                  <div className="bg-gradient-to-r from-[#183864] to-[#2a4d7a] rounded-xl md:rounded-2xl p-6 md:p-8 text-white">
                    <h2 className="text-xl md:text-2xl lg:text-3xl font-bold mb-6 text-center">
                      Why Choose Our Training?
                    </h2>
                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                      <div className="text-center">
                        <div className="text-4xl mb-3">🏆</div>
                        <h3 className="text-lg font-bold mb-2">
                          Industry Leading
                        </h3>
                        <p className="text-base opacity-90">
                          Over 20 years of experience in workplace safety
                          training
                        </p>
                      </div>
                      <div className="text-center">
                        <div className="text-4xl mb-3">📜</div>
                        <h3 className="text-lg font-bold mb-2">
                          Certified Training
                        </h3>
                        <p className="text-base opacity-90">
                          Internationally recognized certifications accepted
                          everywhere
                        </p>
                      </div>
                      <div className="text-center">
                        <div className="text-4xl mb-3">👨‍🏫</div>
                        <h3 className="text-lg font-bold mb-2">
                          Expert Instructors
                        </h3>
                        <p className="text-base opacity-90">
                          Learn from experienced professionals in the field
                        </p>
                      </div>
                      <div className="text-center">
                        <div className="text-4xl mb-3">🤝</div>
                        <h3 className="text-lg font-bold mb-2">
                          Ongoing Support
                        </h3>
                        <p className="text-base opacity-90">
                          Continued assistance even after course completion
                        </p>
                      </div>
                    </div>
                  </div>
                </motion.div>

                {/* Private Group Training CTA */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 1.1 }}
                  className="mb-8 md:mb-12"
                >
                  <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-xl md:rounded-2xl p-6 md:p-8 text-white text-center">
                    <h3 className="text-lg md:text-3xl font-bold mb-4">
                      Corporate Training Solutions
                    </h3>
                    <div className="text-4xl mb-4">🏢</div>
                    <p className="text-sm md:text-lg mb-6 opacity-90 max-w-2xl mx-auto">
                      On-site private group training available—convenient and
                      customized for your team.
                    </p>
                    <div className="flex justify-center">
                      <a
                        href="/contact"
                        className="bg-white text-orange-600 px-6 py-3 rounded-lg font-bold hover:bg-gray-100 transition-colors duration-300"
                      >
                        Inquire Now!
                      </a>
                    </div>
                  </div>
                </motion.div>

                {/* FAQ Section */}
              </div>
            </div>
          </motion.div>
          <div>
            <Frequently />
          </div>
        </div>
      </Layout>
    </>
  );
};

export default CourseAbout;
